import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import GlobalContext from "./context/GlobalContext";

function Sidebar() {
  const { permissible_roles } = useContext(GlobalContext);
  const [cookies] = useCookies(["permissions"]);

  const [isActive, setIsActive] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const location = useLocation();


  // NEW: React State to strictly control dropdowns so re-renders don't close them
  const [openMenus, setOpenMenus] = useState({
    locations: false,
    marketing: false,
    offers: false,
    b2b: false,
      products: false,
      
  });

  const toggleMenu = (e, menuName) => {
    e.preventDefault(); // Stop default link behavior
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName], // Toggle the specific menu
    }));
  };


  useEffect(() => {
    // Extract the current route from the location object
    const currentRoute = location.pathname;

    // Determine the active item based on the current route
    setActiveItem(currentRoute);
  }, [location]);

  const handleMenuClick = (itemName) => {
    setActiveItem(itemName);
  };

  return (
    <>
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav" style={{ marginTop: "50px" }}>
          {permissible_roles.includes("dashboard") ? (
            <>
              <li className={`nav-item ${activeItem === "/" ? "active" : ""}`}>
                <Link
                  className="nav-link"
                  to="/"
                  onClick={() => handleMenuClick("/")}
                >
                  <i className="mdi mdi-grid-large menu-icon"></i>
                  <span className="menu-title">Dashboard</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          {permissible_roles.includes("hubs_dist") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/vendors_data" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/vendors_data"
                  onClick={() => handleMenuClick("/vendors_data")}
                >
                  <i className="menu-icon mdi mdi-factory"></i>
                  <span className="menu-title">Hubs/Distributors</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}

          {permissible_roles.includes("locations") ? (
            <>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="collapse"
                  href="#locations"
                  aria-expanded="false"
                  aria-controls="locations"
                >
                  <i className="menu-icon mdi mdi-map-marker"></i>
                  <span className="menu-title">Locations</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="collapse" id="locations">
                  <ul className="nav flex-column sub-menu">
                    {permissible_roles.includes("locations") ? (
                      <>
                        <li
                          className={`nav-item ${
                            activeItem === "/location" ? "active" : ""
                          }`}
                        >
                          {" "}
                          <Link
                            className="nav-link"
                            to="/location"
                            onClick={() => handleMenuClick("/location")}
                          >
                            Locations
                          </Link>
                        </li>
                      </>
                    ) : (
                      <></>
                    )}
                    {permissible_roles.includes("routes") ? (
                      <>
                        <li className="nav-item">
                          {" "}
                          <Link className="nav-link" to="/routes">
                            Routes
                          </Link>
                        </li>
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              </li>
            </>
          ) : (
            <></>
          )}

          {permissible_roles.includes("customers") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/customers" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/customers"
                  onClick={() => handleMenuClick("/customers")}
                >
                  <i className="menu-icon mdi mdi-account-convert"></i>
                  <span className="menu-title">Customers</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}

    {permissible_roles.includes("marketing") ? (
            <>
              <li className="nav-item">
                <a
                  className="nav-link"
                  onClick={(e) => toggleMenu(e, "marketing")}
                  aria-expanded={openMenus.marketing ? "true" : "false"}
                  style={{ cursor: "pointer" }}
                >
                  <i className="menu-icon mdi mdi-bullhorn"></i>
                  <span className="menu-title">Marketing</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className={`collapse ${openMenus.marketing ? "show" : ""}`} id="marketing">
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item">
                      <Link className="nav-link" to="/banners">
                        Banners
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/marketing">
                        Marketing
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/cart-products">
                        Cart Products
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/recurring-customers">
                        Recurring Customers
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/communication">
                        Communication
                      </Link>
                    </li>

                    {/* NESTED SECTION: Offers & Campaigns */}
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        onClick={(e) => toggleMenu(e, "offers")}
                        aria-expanded={openMenus.offers ? "true" : "false"}
                        style={{
                          cursor: "pointer",
                          paddingLeft: "0",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <span className="menu-title" style={{ fontSize: "0.875rem", color: "#484848" }}>
                          Offers & Campaigns
                        </span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className={`collapse ${openMenus.offers ? "show" : ""}`} id="offers-campaigns">
                        <ul className="nav flex-column sub-menu" style={{ paddingLeft: "15px", listStyle: "none" }}>
                          <li className="nav-item">
                            <Link className="nav-link" to="/all-campaigns" onClick={() => handleMenuClick("/all-campaigns")}>All Campaigns</Link>
                          </li>
                          {/* <li className="nav-item">
                            <Link className="nav-link" to="/coupons-discount" onClick={() => handleMenuClick("/coupons-discount")}>Coupons/Discount</Link>
                          </li> */}
                          {/* <li className="nav-item">
                            <Link className="nav-link" to="/offers" onClick={() => handleMenuClick("/offers")}>Offers</Link>
                          </li> */}
                          {/* <li className="nav-item">
                            <Link className="nav-link" to="/wallet-cashback" onClick={() => handleMenuClick("/wallet-cashback")}>Wallet Cashback</Link>
                          </li> */}
                          <li className="nav-item">
                            <Link className="nav-link" to="/refer-earn" onClick={() => handleMenuClick("/refer-earn")}>Refer & Earn</Link>
                          </li>
                          {/* <li className="nav-item">
                            <Link className="nav-link" to="/review-queue" onClick={() => handleMenuClick("/review-queue")}>Review Queue</Link>
                          </li> */}
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </>
          ) : (
            <></>
          )}

          {permissible_roles.includes("reports") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/reports" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/reports"
                  onClick={() => handleMenuClick("/reports")}
                >
                  <i className="menu-icon mdi mdi-file-document"></i>
                  <span className="menu-title">Reports</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          {permissible_roles.includes("Tablecod") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/TableCod" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/TableCod"
                  onClick={() => handleMenuClick("/TableCod")}
                >
                <i className="menu-icon mdi mdi-cash"></i>
                  <span className="menu-title">Cod-Orders</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}


{permissible_roles.includes("products") && (
  <li
    className="nav-item"
    style={{
      background: openMenus.products ? "#fff" : "transparent",
      borderRadius: "0 30px 30px 0",
      overflow: "hidden",
    }}
  >
    <a
      className="nav-link"
      onClick={(e) => toggleMenu(e, "products")}
      aria-expanded={openMenus.products ? "true" : "false"}
      style={{ cursor: "pointer", background: "transparent" }}
    >
      <i className="menu-icon mdi mdi-package-variant"></i>
      <span className="menu-title">Products</span>
      <i className="menu-arrow"></i>
    </a>

    <div
      className={`collapse ${openMenus.products ? "show" : ""}`}
      style={{ background: "transparent" }}
    >
      <ul
        className="nav flex-column sub-menu"
        style={{ background: "transparent", paddingBottom: "10px" }}
      >
        <li
          className={`nav-item ${activeItem === "/products" ? "active" : ""}`}
          style={{ background: "transparent" }}
        >
          <Link
            className="nav-link"
            to="/products"
            onClick={() => handleMenuClick("/products")}
          >
            All Products
          </Link>
        </li>
        <li
          className={`nav-item ${activeItem === "/sub-products" ? "active" : ""}`}
          style={{ background: "transparent" }}
        >
          <Link
            className="nav-link"
            to="/sub-products"
            onClick={() => handleMenuClick("/sub-products")}
          >
            Sub Products
          </Link>
        </li>
      </ul>
    </div>
  </li>
)}



          {permissible_roles.includes("tickets") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/tickets" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/tickets"
                  onClick={() => handleMenuClick("/tickets")}
                >
                  <i className="menu-icon mdi mdi-ticket"></i>
                  <span className="menu-title">Tickets</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}

          {permissible_roles.includes("b2b") ? (
            <>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="collapse"
                  href="#b2b"
                  aria-expanded="false"
                  aria-controls="b2b"
                >
                  <i className="menu-icon mdi mdi-briefcase-account"></i>
                  <span className="menu-title">B2B</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="collapse" id="b2b">
                  <ul className="nav flex-column sub-menu">
                    {permissible_roles.includes("b2b") && (
                      <>
                        <li
                          className={`nav-item ${
                            activeItem === "/cafe-management" ? "active" : ""
                          }`}
                        >
                          <Link
                            className="nav-link"
                            to="/cafe-management"
                            onClick={() => handleMenuClick("/cafe-management")}
                          >
                            Cafe Management
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/cafe-summary">
                            Summary
                          </Link>
                        </li>
                        <li
                          className={`nav-item ${
                            activeItem === "/b2b_banner" ? "active" : ""
                          }`}
                        >
                          <Link
                            className="nav-link"
                            to="/b2b_banner"
                            onClick={() => handleMenuClick("/b2b_banner")}
                          >
                            B2b Banner
                          </Link>
                        </li>
                       
                        <li
                          className={`nav-item ${
                            activeItem === "/OrderSumary" ? "active" : ""
                          }`}
                        >
                          <Link
                            className="nav-link"
                            to="/OrderSumary"
                            onClick={() => handleMenuClick("/OrderSumary")}
                          >
                            cafehistory
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </li>
            </>
          ) : (
              <></>
          )}
              

          {permissible_roles.includes("inventory") ? (
            <>
              <li
                className={`nav-item ${
                  activeItem === "/inventory-management" ? "active" : ""
                }`}
              >
                <Link
                  className="nav-link"
                  to="/inventory-management"
                  onClick={() => handleMenuClick("/inventory-management")}
                >
                  <i className="menu-icon mdi mdi-warehouse"></i>
                  <span className="menu-title">Inventory</span>
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          {/* {permissible_roles.includes("lowbalance") ? (
            <>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="collapse"
                  href="#lowbalance"
                  aria-expanded="false"
                  aria-controls="lowbalance"
                >
                  <i className="menu-icon mdi mdi-account-convert"></i>
                  <span className="menu-title">Low Balance</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="collapse" id="lowbalance">
                  <ul className="nav flex-column sub-menu">
                  {permissible_roles.includes("lb_dashboard") ? 
                    <li className="nav-item">
                      {" "}
                      <Link className="nav-link" to="/lowbalance-dashboard">
                        Dashboard
                      </Link>
                    </li>
                      : <></>
                      }
                      {permissible_roles.includes("lb_task") ? 
                    <li className="nav-item">
                      {" "}
                      <Link className="nav-link" to="/lowbalance-assign-task">
                        Assign Task
                      </Link>
                    </li>
                    : <></> 
                    }
                    
                  </ul>
                </div>
              </li>
            </>
          ) : (
            <></>
          )} */}
        </ul>
      </nav>
    </>
  );
}

export default Sidebar;